import { render, staticRenderFns } from "./mText.vue?vue&type=template&id=41db5359&"
import script from "./mText.vue?vue&type=script&lang=js&"
export * from "./mText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports